import logo from "./assets/logo.png";

function About() {
  return (
    <section
      className="about-section"
      style={{
        backgroundImage: `
          linear-gradient(rgba(0,0,0,0.75), rgba(0,0,0,0.75)),
          url("https://galooli.com/wp-content/uploads/2020/04/what-is-hvac-featured-image.jpg")
        `,
      }}
    >
      <div className="about-container">

        <div className="about-text">
          <h2>About F.D Ventilation</h2>

          <p>
            F.D Ventilation delivers complete HVAC solutions including design,
            fabrication, installation and long-term maintenance services.
          </p>

          <p>
            With extensive experience in industrial and residential projects,
            our team ensures system performance, energy efficiency and full
            compliance with modern ventilation standards.
          </p>

          <p>
            Our maintenance programs reduce operational costs, prevent system
            failures and guarantee long-term reliability.
          </p>

          <p>
            From residential systems to large VRF and chiller installations,
            we provide precision engineering and professional execution.
          </p>
        </div>

        <div className="about-side-logo">
          <img src={logo} alt="F.D Ventilation Logo" />
        </div>

      </div>
    </section>
  );
}

export default About;
